// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start Product Demo & Description Section*/
.product-des {
  margin-left: 40px;
}

.product-demo-v img {
  height: auto;
  width: 100%;
}

.heading h1 {
  font-size: 37px;
  font-weight: 700;
  margin-bottom: 0px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--blue);
}

.heading h1 span {
  color: var(--dPink);
}

.product-name h1 {
  color: var(--black);
}

.product-info {
  display: flex;
  column-gap: 70px;
  align-items: center;
}

.product-age-group p,
.session-count p,
.product-rating span {
  font-weight: 700;
  margin: 20px 0px;
  letter-spacing: 1px;
}

.product-price-wd p {
  color: var(--dPink);
  font-weight: 500;
  font-size: 24px;
}

.about-product p {
  text-align: justify;
}

.star {
  color: var(--grey);
}

.rated-star {
  color: #fece00;
}

.explore-course-btn {
  background-color: var(--dBlue);
  border-radius: 50px;
  width: 80%;
  padding: 12px;
  font-weight: 700;
  margin-top: 20px;
  text-transform: uppercase;
}

.product-page-slider{
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 50vh;
}

.product-page-slider .item {
  display: none;
  height: 100%;
  overflow: hidden;
}

.product-page-slider .item.active {
  display: block;
}

.product-page-slider button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: var(--dPink);
  color: #fff;
  border: none;
  font-size: 18px;
  cursor: pointer;
  border-radius: 50%;
}

.product-page-slider .prev {
  left: 10px;
}

.product-page-slider .next {
  right: 10px;
}

.product-thumbnail-wrapper {
  width: 100%;
  height: 50vh;
}

.product-thumbnail-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-page-tab li {
  display: inline;
  display: initial;
  padding: 15px 30px;
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.slider-dots {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: absolute;
  bottom: -20px;
  /* background: #000; */
  transform: translateX(-50%);
  left: 50%;
}

.dot {
  width: 10px;
  height: 10px;
  background-color: #bbb;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
}

.dot.active {
  background-color: #333;
}

/*End Product Demo & Description Section */

/* Responsive CSS */
@media (max-width: 1024px) {
  .product-page-tab {
    column-gap: 5px;
  }

  .product-page-tab li {
    padding: 15px;
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .product-info {
    column-gap: 5px;
  }

  .product-des {
    margin: 0px;
  }

  .heading h1 {
    font-size: 2rem;
  }

  .product-name {
    padding-top: 30px;
  }

  .product-age-group p,
  .session-count p,
  .product-rating span {
    font-size: 14px;
  }

  .product-page-tab {
    column-gap: 8px;
    padding: 0 5px;
  }

  .product-page-tab li {
    padding: 10px 0px;
    font-size: 12px;
  }

  .product-page-tab .active {
    padding: 10px 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/product-page/ProductPage.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAc;EAAd,gBAAc;EACd,kBAAkB;EAClB,qCAA6B;EAA7B,kCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0CAA0C;;AAE1C,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Start Product Demo & Description Section*/\n.product-des {\n  margin-left: 40px;\n}\n\n.product-demo-v img {\n  height: auto;\n  width: 100%;\n}\n\n.heading h1 {\n  font-size: 37px;\n  font-weight: 700;\n  margin-bottom: 0px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--blue);\n}\n\n.heading h1 span {\n  color: var(--dPink);\n}\n\n.product-name h1 {\n  color: var(--black);\n}\n\n.product-info {\n  display: flex;\n  column-gap: 70px;\n  align-items: center;\n}\n\n.product-age-group p,\n.session-count p,\n.product-rating span {\n  font-weight: 700;\n  margin: 20px 0px;\n  letter-spacing: 1px;\n}\n\n.product-price-wd p {\n  color: var(--dPink);\n  font-weight: 500;\n  font-size: 24px;\n}\n\n.about-product p {\n  text-align: justify;\n}\n\n.star {\n  color: var(--grey);\n}\n\n.rated-star {\n  color: #fece00;\n}\n\n.explore-course-btn {\n  background-color: var(--dBlue);\n  border-radius: 50px;\n  width: 80%;\n  padding: 12px;\n  font-weight: 700;\n  margin-top: 20px;\n  text-transform: uppercase;\n}\n\n.product-page-slider{\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  height: 50vh;\n}\n\n.product-page-slider .item {\n  display: none;\n  height: 100%;\n  overflow: hidden;\n}\n\n.product-page-slider .item.active {\n  display: block;\n}\n\n.product-page-slider button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--dPink);\n  color: #fff;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.product-page-slider .prev {\n  left: 10px;\n}\n\n.product-page-slider .next {\n  right: 10px;\n}\n\n.product-thumbnail-wrapper {\n  width: 100%;\n  height: 50vh;\n}\n\n.product-thumbnail-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-page-tab li {\n  display: unset;\n  padding: 15px 30px;\n  width: fit-content !important;\n}\n\n.slider-dots {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  position: absolute;\n  bottom: -20px;\n  /* background: #000; */\n  transform: translateX(-50%);\n  left: 50%;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  background-color: #bbb;\n  border-radius: 50%;\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.dot.active {\n  background-color: #333;\n}\n\n/*End Product Demo & Description Section */\n\n/* Responsive CSS */\n@media (max-width: 1024px) {\n  .product-page-tab {\n    column-gap: 5px;\n  }\n\n  .product-page-tab li {\n    padding: 15px;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .product-info {\n    column-gap: 5px;\n  }\n\n  .product-des {\n    margin: 0px;\n  }\n\n  .heading h1 {\n    font-size: 2rem;\n  }\n\n  .product-name {\n    padding-top: 30px;\n  }\n\n  .product-age-group p,\n  .session-count p,\n  .product-rating span {\n    font-size: 14px;\n  }\n\n  .product-page-tab {\n    column-gap: 8px;\n    padding: 0 5px;\n  }\n\n  .product-page-tab li {\n    padding: 10px 0px;\n    font-size: 12px;\n  }\n\n  .product-page-tab .active {\n    padding: 10px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
